// Utilities
import { lazy } from "react";
import { retry } from "@ms/uno-utilities/lib/local/RetryUtilities";
export const ConvertPlanContainerLazyLoader = ()=>retry(()=>import(/* webpackChunkName: "uno-convertplancontainer" */ "./ConvertPlanContainer")).then((bundle)=>{
        return {
            default: bundle.ConvertPlanContainer
        };
    });
export const LazyConvertPlanContainer = /*#__PURE__*/ lazy(ConvertPlanContainerLazyLoader);
